import { Card } from "../../../components/Card";
import { ReactComponent as ChevronRightIcon } from "../../../assets/icons/chevron-left.svg";
import { BadgeView } from "./BadgeView";
import { LockWithTooltip } from "./LockWithTooltip";
import { AchievementsWidgetBadgesSkeleton } from "./AchievementsWidgetSkeleton";
import { AchievementDetailModal } from "./AchievementDetailModal";
import { useQuery } from "@tanstack/react-query";
import { api as badgeCenterApi } from "../../../services/apis/badge-center";
import { useUser } from "../../../services/user-context";
import { useState } from "react";

export function AchievementsWidget({ onAchievementFullView, isLocked }: { onAchievementFullView: () => void, isLocked: boolean }) {
    
    const { userInfo } = useUser() as any;
    const [selectedAchievement, setSelectedAchievement] = useState<any>(null);
    
    const { data: achievementsQuickView, isLoading: isLoadingAchievementsQuickView } = useQuery({
        queryKey: ["achievements-quick-view"],
        queryFn: () => badgeCenterApi.getAchievementsQuickView(4),
        enabled: !!userInfo?.id,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });

    const achievements = achievementsQuickView?.achievements || [];
    const showBadgeSkeleton = !userInfo?.id || isLoadingAchievementsQuickView;

    return (
        <Card className="!p-[18px]">
            <div className="flex flex-col mb-2">
                <div className="flex flex-col gap-1 mb-2">

                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-1.5">
                            {isLocked ? <LockWithTooltip /> : <></>}
                            <span className="text-base font-semibold text-black">Achievements</span>
                        </div>
                        <button onClick={onAchievementFullView} className="flex items-center gap-1 text-black text-base">View All <ChevronRightIcon className=" rotate-[180deg]" /></button>
                    </div>
                    <div>Build your skills and earn badges</div>
                </div>
                {showBadgeSkeleton ? (
                    <AchievementsWidgetBadgesSkeleton />
                ) : (
                    <div className="flex items-center justify-between gap-2">
                        {achievements.map((achievement: any) => (
                            <button
                                key={achievement.slug}
                                type="button"
                                onClick={() => setSelectedAchievement(achievement)}
                                className="hover:opacity-80 transition-opacity"
                            >
                                <BadgeView title={achievement.name} data={achievement} />
                            </button>
                        ))}
                    </div>
                )}
            </div>
            {selectedAchievement && (
                <AchievementDetailModal
                    achievement={selectedAchievement}
                    onClose={() => setSelectedAchievement(null)}
                />
            )}
        </Card>
    )
}